import { useSyncExternalStore } from 'react';

export interface EncounterRolloutSnapshot {
  traitPopoverEnabled: boolean;
  paginationEnabled: boolean;
}

const DEFAULT_SNAPSHOT: EncounterRolloutSnapshot = {
  traitPopoverEnabled: true,
  paginationEnabled: true,
};

let snapshot = DEFAULT_SNAPSHOT;
const listeners = new Set<() => void>();

export function configureEncounterRollout(config: {
  traitPopoverEnabled?: boolean;
  paginationEnabled?: boolean;
}): void {
  const next = {
    traitPopoverEnabled: config.traitPopoverEnabled ?? snapshot.traitPopoverEnabled,
    paginationEnabled: config.paginationEnabled ?? snapshot.paginationEnabled,
  };
  if (
    next.traitPopoverEnabled === snapshot.traitPopoverEnabled
    && next.paginationEnabled === snapshot.paginationEnabled
  ) {
    return;
  }
  snapshot = next;
  listeners.forEach((listener) => listener());
}

export function getEncounterRolloutSnapshot(): EncounterRolloutSnapshot {
  return snapshot;
}

export function useEncounterRollout(): EncounterRolloutSnapshot {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    getEncounterRolloutSnapshot,
    () => DEFAULT_SNAPSHOT,
  );
}
